import React from 'react';
import { Box, Divider, Grid, Paper, Typography } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { FlexBox } from '../../global/FlexBox';

const DetailsBox = () => (
  <Box display="flex" flexDirection="column" width="100%">
    <Skeleton variant="text" height={22} width="50%" />
    <Skeleton variant="text" height={22} width="30%" />
  </Box>
);

const TreeBox = () => (
  <Box
    display="flex"
    flexDirection="column"
    width="100%"
    style={{
      border: '1px solid #E1E4E8',
      borderRadius: 8,
      padding: '12px 16px',
    }}
  >
    <Skeleton variant="text" height={22} width="50%" />
    <Skeleton
      variant="text"
      height={22}
      width="25%"
      style={{ marginLeft: 16 }}
    />
    <Skeleton
      variant="text"
      height={22}
      width="25%"
      style={{ marginLeft: 16 }}
    />
  </Box>
);
export const UserDetailsSkeleton = () => {
  return (
    <Grid container>
      <Grid item xs={5}>
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          alignItems="center"
          gridColumnGap={8}
          marginBottom={5}
        >
          <Skeleton variant="text" height={22} width="30%" />
          <Typography variant="h5" color="textSecondary" style={{ margin: 0 }}>
            &gt;
          </Typography>
          <Skeleton variant="text" height={22} width="30%" />
        </Box>
        <FlexBox direction="column" width="100%" gridRowGap={24}>
          <DetailsBox />
          <DetailsBox />
          <DetailsBox />
        </FlexBox>
      </Grid>
      <Grid item xs={7}>
        <Paper style={{ height: '100%' }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            style={{ padding: '24px 48px' }}
          >
            <Skeleton variant="text" height={42} width="50%" />
            <Box
              display="flex"
              alignItems="center"
              style={{ gap: 16 }}
              width="100%"
              justifyContent="flex-end"
            >
              <Skeleton variant="text" height={42} width="25%" />
              <Skeleton variant="text" height={42} width="25%" />
            </Box>
          </Box>
          <Divider />
          <Box
            display="flex"
            flexDirection="column"
            width="100%"
            style={{ padding: 48 }}
          >
            <Skeleton variant="text" height={22} width="50%" />
            <Skeleton variant="text" height={22} width="50%" />
            <Box
              display="flex"
              flexDirection="column"
              width="100%"
              gridRowGap={16}
              marginTop={4}
            >
              <TreeBox />

              <TreeBox />
            </Box>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
